
import { Component, Prop, Vue } from "vue-property-decorator";
import anime from "animejs";

@Component
export default class About extends Vue {

  mounted() {
    // About Me
    let loaded = false;
    new IntersectionObserver((entries) => {
    if (entries[0].intersectionRatio <= 0) return;
    if (!loaded) {
      loaded = true;
      anime({
        targets: [".profile", ".about-txt"],
        translateY: 200,
        duration: 1000,
        direction: 'reverse',
        color: 'rgba(0, 0, 0, 0)',
        easing: 'easeInOutSine',
        delay: 4000
      });
    }}).observe(this.$refs.about as Element);
  }

}
